/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseGroupsGroupIdNotFound
 */
export interface GetUniverseGroupsGroupIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseGroupsGroupIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseGroupsGroupIdNotFound interface.
 */
export function instanceOfGetUniverseGroupsGroupIdNotFound(value: object): value is GetUniverseGroupsGroupIdNotFound {
    return true;
}

export function GetUniverseGroupsGroupIdNotFoundFromJSON(json: any): GetUniverseGroupsGroupIdNotFound {
    return GetUniverseGroupsGroupIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseGroupsGroupIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseGroupsGroupIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseGroupsGroupIdNotFoundToJSON(json: any): GetUniverseGroupsGroupIdNotFound {
    return GetUniverseGroupsGroupIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseGroupsGroupIdNotFoundToJSONTyped(value?: GetUniverseGroupsGroupIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

